<template>
  <div class="inside">
    <div class="title" v-html="title" v-if="false"></div>
    <!-- <div ref="mirko" class="inside-in" v-html="page"></div> -->
    <div id="page" class="inside-in"></div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'inside',
  data () {
    return {
      title:'',
      page: '',
      html:''
    }
  },
  created () {
    console.log("Arrivo al Inside.vue con page  "+this.$route.params.page)
    this.fetchData()

    
    /*
    var vm = new Vue({
      render: res.render,
      staticRenderFns: res.staticRenderFns
    })
    vm.$mount('#someElement')
    */
    
    //var $element = this.$refs.ppp.append('<b>Scrivo del testo</b>')
    //this.$compile('<b>Scrivo del testo</b>')
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.loading = true      
      var parent = this
      this.axios.get('page/'+this.$route.params.page+'.html',{responseType: 'document'})
        .then(function (response) {
            parent.title = response.request.response.body.children.item(0).innerHTML
            document.title = parent.title
/* 
            for (let metaList of document.getElementsByTagName("META")){
              if(metaList.getAttribute("property")=='og:url')
                metaList.setAttribute("content",document.location)
              if(metaList.getAttribute("property")=='og:title')
                metaList.setAttribute("content",parent.title)
              if(metaList.getAttribute("property")=='og:description')
                metaList.setAttribute("content",response.request.response.body.children.item(2).innerHTML)
              if(metaList.getAttribute("property")=='og:image')
                metaList.setAttribute("content",'http://www.dapstudio.com/site/images/'+response.request.response.body.children.item(3).innerHTML)
               
              //console.log(metaList.getAttribute("property"))
     //metaList[0].setAttribute("content","noarchive");
            }

*/
            //parent.page = response.request.response.body.children.item(1).innerHTML
            //parent.$compile(parent.$refs.mirko)
            //console.log(parent.$refs.mirko)

            var res = Vue.compile('<div id="page" class="inside-in">'+response.request.response.body.children.item(1).innerHTML+'</div>')
            var vm = new Vue({
              router: parent.$router,
              render: res.render,
              staticRenderFns: res.staticRenderFns
            })
            vm.$mount('#page')


    console.log(res)

        })
        .catch(function (error) {
            console.log(error)
          parent.$route.push('/inside/error/not-find')
        })

     
    }
  }
}
</script>


<style>
.inside-in{
  padding-bottom:40px;
}.inside .title{
   text-transform:uppercase;
  font-size:1.4rem;
  padding:10px 0;
  margin:0;
  color: #222222;
  font-weight: 700;

}.img-double .m6, .img-double .col-s12, .img-single .col-s12{
  margin-top:50px;
}.img-double img, .img-single img, .inside img.main-top-3col{
  width:100%;


}@media only screen and (min-width: 601px){

.img-double .col.m6:nth-child(odd) {
  padding-right:25px;
}.img-double .col.m6:nth-child(even) {
  padding-left:25px;
}

}
</style>



// WEBPACK FOOTER //
// Inside.vue?30351368